.ha-dialog-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3002;
  background: rgba(0, 0, 0, 0.36);
  display: flex;
  align-items: center;
  justify-content: center;
  animation-name: fade-in;
  animation-duration: 0.2s;
  color: #4a4a4a;
}

.ha-dialog-no-bg {
  background: transparent;
}

.ha-dialog {
  background: #fff;
  padding: 11px;
  box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12),
    0 11px 15px -7px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.ha-dialog-appear {
  animation-duration: 0.2s;
  animation-name: dialog-appear;
}

.ha-dialog-title {
  font-weight: bold;
  margin-bottom: 16px;
}

.ha-dialog-body {
  font-size: 14px;
  padding-right: 10px;
  line-height: 1.4;
}

.ha-dialog-cancel {
  color: #a8a8a8 !important;
  text-transform: none !important;
  height: 32px;
  margin-top: 10px !important;
  font-weight: 500 !important;
}

.ha-dialog-done {
  color: #37bac4 !important;
  text-transform: none !important;
  height: 32px;
  margin-top: 10px !important;
  font-weight: 500 !important;
  margin-left: 4px;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes dialog-appear {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
